// extracted by mini-css-extract-plugin
export default {"backToTop":"BackToTop_backToTop__2gQzO","visible":"BackToTop_visible__b8P9O","transparent":"BackToTop_transparent__LEBWm"};